const Footer = () => {
  return <footer className="app-footer text-center p-2"></footer>;
};

export default Footer;
